const setResizeListener = (callback) => {
  let pending = false;

  let doResize = (width) => {
    if (!pending && !!width) {
      pending = true;
      window.requestAnimationFrame(() => {
        callback(width);
        pending = false;
      });
    }
  };

  // innerWidth matches typical CSS min-width viewport behavior (e.g. Bootstrap lg at 992px).
  // clientWidth can sit ~one scrollbar below innerWidth and left JS "MD" while CSS still applies lg,
  // which produced an empty sidebar column with KCO summary inlined in the main column.
  const getViewportWidth = () =>
    typeof window !== 'undefined' ? window.innerWidth : 0;

  const handleResize = () => {
    doResize(getViewportWidth());
  };

  window.addEventListener('resize', handleResize, true);

  doResize(getViewportWidth());

  return () => {
    window.removeEventListener('resize', handleResize, true);
  };
};

export default setResizeListener;
